import { useState } from "react";
import Navbar from "../../../components/navbar/navbarComponent";
import { ActionCircleIcon } from "../../../components/icons/SvgIcons";
import ACompactarComponent from "./aCompactar/aCompactarTable";
import CompactadosComponent from "./compactados/compactadosTable";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CompactacionComponent = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const tipoCurrentUser = useSelector((state) => state.tipoCurrentUser);

  const isAdmin = tipoCurrentUser === "admin" || tipoCurrentUser === "super_admin";
  const isUser = tipoCurrentUser === "user" || tipoCurrentUser === "super_admin";

  const [activeTab, setActiveTab] = useState(isAdmin ? "tab1" : "tab2");

  return (
    <div className="bg-[#F5FAFF] flex flex-col justify-center">
      <Navbar />

      <button
        onClick={handleBackClick}
        className="z-50 absolute top-28 left-12 sm:top-28 sm:left-20 lg:left-52
               flex items-center justify-center p-2 rounded-full
               hover:drop-shadow-[3px_3px_5px_rgba(0,0,0,0.3)]
               transition ease-in-out duration-200"
      >
        <ActionCircleIcon className="flex flex-start h-12 drop-shadow-[2px_2px_4px_rgba(0,0,0,0.3)]" />
      </button>


      <div className="min-h-screen">
        <div className="flex  flex-col items-center w-full h-full gap-8">
          <div className="flex flex-col justify-center items-center text-center sm:mt-[2rem] mt-[4rem] w-full">
            <div className="text-[#3d4245] text-[2rem]  font-bold font-inter">
              Compactaciones
            </div>
          </div>
        </div>

        <div className="w-full max-w-xl mx-auto mt-8 px-[1rem]">
          {/* Solapas */}
          <div className="flex border-b border-gray-200">
            {isAdmin && (
              <button
                className={`px-4 py-2 font-semibold text-sm ${activeTab === "tab1"
                    ? "border-b-2 border-blue-600 text-blue-600"
                    : "text-gray-500 hover:text-blue-600"
                  }`}
                onClick={() => setActiveTab("tab1")}
              >
                Ingresados
              </button>
            )}
            {isUser && (
              <button
                className={`px-4 py-2 font-semibold text-sm ${activeTab === "tab2"
                    ? "border-b-2 border-blue-600 text-blue-600"
                    : "text-gray-500 hover:text-blue-600"
                  }`}
                onClick={() => setActiveTab("tab2")}
              >
                A compactar
              </button>
            )}
          </div>

          {/* Contenido de solapas */}
          <div className=" bg-white border border-t-0 border-gray-200 rounded-b-lg">
            {activeTab === "tab1" && (
              <div>
                {/*Contenido de Ingresados */}
                <ACompactarComponent />
              </div>
            )}
            {activeTab === "tab2" && (
              <div>
                {/* Contenido de A compactar*/}
                <CompactadosComponent />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompactacionComponent;
